/**
 * 裝置特徵偵測：輸入能力 (Hover) + 視窗尺寸分級 (Breakpoint)
 * 全域單例：整個 App (overlay/ 與 studio/) 共用同一份判斷來源與監聽器，避免各處邏輯漂移。
 *
 * 斷點門檻只在 variables.css 的 @media 裡維護一份 (寫進 --breakpoint)，
 * 這裡單純讀回計算後的 CSS 變數，不在 JS 端重複維護門檻數字，避免兩邊定義漂移。
 */
const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)')
const listeners = new Set()

/** 讀回 variables.css 依目前斷點算出的 --breakpoint 值 */
const _readBreakpoint = () => {
    return getComputedStyle(document.documentElement).getPropertyValue('--breakpoint').trim() || 'desktop'
}

export const device = {
    hasHover: hoverQuery.matches, // 是否具備穩定 Hover 能力 (滑鼠/觸控板)
    breakpoint: _readBreakpoint() // 'mobile' | 'desktop'
}

const _notify = () => {
    for (const cb of listeners) {
        cb(device)
    }
}

hoverQuery.addEventListener('change', (e) => {
    device.hasHover = e.matches
    _notify()
})

let _rafId = null
window.addEventListener('resize', () => {
    if (_rafId !== null) {
        return
    }

    _rafId = requestAnimationFrame(() => {
        _rafId = null

        const breakpoint = _readBreakpoint()
        if (breakpoint === device.breakpoint) {
            return
        }

        device.breakpoint = breakpoint
        _notify()
    })
})

/**
 * 訂閱裝置特徵變化 (Hover 能力 / 尺寸分級)
 * @param {(device: typeof device) => void} cb
 * @returns {() => void} 取消訂閱函式
 */
export const onDeviceChange = (cb) => {
    listeners.add(cb)
    return () => {
        listeners.delete(cb)
    }
}
